// OverallAccountExcel.js
import * as XLSX from 'xlsx';

const generateOverallAccountExcel = (overallData) => {
    const formattedData = overallData.map((item, index) => ({
      'Sr No': index + 1,
      'Restaurant Name': item.restaurant_name,
      'Balance (₹)': `${parseFloat(item.balance || 0).toLocaleString() } ${ item.balance_label || ''}`,
    }));
  
    // Create a worksheet from JSON data (starting from row 3 to leave space for heading)
    const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });
  
    // Add heading/title
    XLSX.utils.sheet_add_aoa(worksheet, [
      ['Overall Restaurant Account Report'], // title
      [], // empty row
      ['Sr No', 'Restaurant Name', 'Balance (₹)'], // column headers
    ], { origin: 'A1' });
  
    // Add the data rows starting from row 4
    XLSX.utils.sheet_add_json(worksheet, formattedData, {
      origin: 'A4',
      skipHeader: true,
    });
  
    // Merge cells for title (merge A1 to C1)
    worksheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }, // A1:C1
    ];
  
    // Set column widths
    worksheet['!cols'] = [
      { wch: 10 }, // Sr No
      { wch: 30 }, // Restaurant Name
      { wch: 20 }, // Balance
    ];
  
    // Create workbook and export
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Overall Account Report');
    XLSX.writeFile(workbook, 'Overall_Restaurant_Account_Report.xlsx');
  };

export default generateOverallAccountExcel;
